import React, { useState, useRef, useEffect } from 'react';
import { MoreHorizontal } from 'lucide-react';

/**
 * Menu "Altro" (⋯) per le azioni secondarie di una pagina: tiene pulita
 * l'intestazione lasciando in vista solo l'azione principale.
 * items: [{ label, icon: Icon, onClick, disabled?, danger?, hidden? }]
 */
export default function MoreMenu({ items, label = 'Altro', align = 'right' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const k = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', h);
    document.addEventListener('keydown', k);
    return () => { document.removeEventListener('mousedown', h); document.removeEventListener('keydown', k); };
  }, [open]);
  const visibili = items.filter(i => !i.hidden);
  if (!visibili.length) return null;
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button className="eden-btn is-icon" onClick={() => setOpen(o => !o)} aria-haspopup="menu" aria-expanded={open} aria-label={label} title={label}>
        <MoreHorizontal size={18} />
      </button>
      {open && (
        <div className="eden-menu eden-toast-in" role="menu"
          style={{ position: 'absolute', top: 'calc(100% + 6px)', [align]: 0, minWidth: 230, zIndex: 60 }}>
          {visibili.map(it => (
            <button key={it.label} role="menuitem" className="eden-menu-item" disabled={it.disabled}
              style={{ color: it.danger ? 'var(--red)' : undefined, opacity: it.disabled ? 0.5 : 1 }}
              onClick={() => { setOpen(false); it.onClick(); }}>
              {it.icon && <it.icon size={15} />}{it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
